/**
 * The structured data for the models is currently stored in a JSON file.
 */
import modelInfo from './modelsFinal.json';
import {type Model, type ModelInfo} from './types';
import {
  getInferenceServerForHostname,
  isInferenceDevelopmentHostname,
} from './util';

// TODO: On load, calculate some summary statistics we could use for visualization or filters.

export const MODEL_INFO = modelInfo as ModelInfo;

export const filterModelsForInferenceHost = (
  models: Model[],
  hostname: string
): Model[] => {
  const server = getInferenceServerForHostname(hostname);
  if (server !== undefined) {
    return models.filter(model => model.availableIn.includes(server));
  }
  if (isInferenceDevelopmentHostname(hostname)) {
    return models.filter(model => model.availableIn.length > 0);
  }
  return models;
};

MODEL_INFO.models = filterModelsForInferenceHost(
  MODEL_INFO.models,
  window.location.hostname
);

export const getHuggingFaceUrl = (modelId: string) => {
  return `https://huggingface.co/${modelId}`;
};

MODEL_INFO.models.forEach((model: Model) => {
  if (model.idHuggingFace) {
    model.urlHuggingFace = getHuggingFaceUrl(model.idHuggingFace);
  }
});

// Create a mapping from model id to model object.
export const MODEL_INDEX = MODEL_INFO.models.reduce(
  (acc, m) => {
    acc[m.id] = m;
    return acc;
  },
  {} as Record<string, Model>
);

// Create a mapping from idHuggingFace to our internal model id (which is better for URLs)
// TODO: We could alternatively just formalize our ID conversion rule.
export const HUGGINGFACE_ID_TO_MODEL_ID = MODEL_INFO.models.reduce(
  (acc, model) => {
    if (model.idHuggingFace) {
      acc[model.idHuggingFace] = model.id;
    }
    return acc;
  },
  {} as Record<string, string>
);

export const getHostedModels = (): Model[] => {
  return MODEL_INFO.models.filter(
    model => model.status === 'hosted' && !model.isHidden
  );
};

export const getModelsByIds = (modelIds: string[]): Model[] => {
  return modelIds
    .map(id => MODEL_INDEX[id])
    .filter((model): model is Model => model != null);
};
